export default {
    // 封装图片限制
    ImageRestrictions(width, height, type) {
        if (type === 1 && width / height === 34.5 / 14) {
            return true
        }
        if (type === 2 && width / height === 34.5 / 18.6) {
            return true
        }
        if (type === 3 && width / height === 34.5 / 15) {
            return true
        }
        if (type === 4 && width / height === 108 / 192) {
            return true
        }
        if (type === 5 && width / height === 9 / 9) {
            return true
        }
        if (type === 6 && width / height === 12 / 12) {
            return true
        }
        if (type === 7 && width === 690 && height === 240) {
            return true
        }
        if (type === 8 && width / height === 69 / 28) {
            return true
        }
        if (type === 9 && width / height === 7.5 / 6) {
            return true
        }
        if (type === 10 && width / height === 56 / 67) {
            return true
        }

        return false
    }
}


// WEBPACK FOOTER //
// ./src/commit/commit.js